import { render } from "./VPNEntity.vue?vue&type=template&id=6db6b07d"
import script from "./VPNEntity.vue?vue&type=script&lang=js"
export * from "./VPNEntity.vue?vue&type=script&lang=js"

import "./VPNEntity.vue?vue&type=style&index=0&id=6db6b07d&lang=scss"

import exportComponent from "/opt/app-root/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__